/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import IAppDownloadContext from "../../../Basis/Components/AppDownloadContext/IAppDownloadContext";
import StripeClient from "../Api/StripeClient";
import Belegart from "../Queries/Belegart";

export default class MandantBelegUtil {
    public static async downloadPdf(
        stripeClient: StripeClient,
        appDownloadContext: IAppDownloadContext,
        belegart: Belegart,
        belegId: string) {
        const datei = belegart === "RECHNUNG" ?
            await stripeClient.rechnungPdfLaden(belegId) :
            await stripeClient.gutschriftPdfLaden(belegId);
        const url = window.URL.createObjectURL(datei);
        appDownloadContext.ladeHerunter(url, datei.name);
    }
}